import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { RatingSelection } from '../../components';
import { FrontendUtils } from '@reviews/frontend';

export const RatingSelectionView: React.FC = () => {
    const [searchParams] = useSearchParams();

    const reservationId = searchParams.get('reservation');
    const confirmationCode = searchParams.get('confirmation') ?? '';
    const nsuHash = searchParams.get('nsu') ?? '';
    const disposition = searchParams.get('disposition') ?? '';

    useEffect(() => {
        FrontendUtils.SharedUtils.setBaseItemForTracking(reservationId, confirmationCode, nsuHash, disposition, null);

        const footer = document.getElementById('footer');
        if (footer) {
            footer.classList.add('fix-bottom');
        }
    }, [confirmationCode, disposition, nsuHash, reservationId]);

    return <RatingSelection />;
};
